export const RoleNames = {
   roles: 'roles',
   name: 'name',
   resources: 'resources',
   members: 'members',

   ldapGroupFilter: 'ldapGroupFilter',
   includeLdapUsers: 'includeLdapUsers',
} as const;

export const DiplomatAdminUserGroupNames = {
   userIds: 'userIds',
   allUsers: 'allUsers',
   users: 'users',
};
